export default {
  lang: {
    reset: 'إعادة التعيين',
    search: 'الفحص',
    expand: 'تتكشف',
    collapse: 'ابعد عن هذا',
  },
};
